import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { Link } from 'components';

import styles from './styles.pcss';
const cx = classNames.bind(styles);

const ofertaType = {
  gPay: {
    name: 'GPay',
    link: 'https://static.beeline.ru/upload/images/promoforge/docs/oferta_googlePay.pdf',
  },
  appPay: {
    name: 'Apple Pay',
    link: 'https://static.beeline.ru/upload/images/promoforge/docs/oferta_applePay.pdf',
  },
};

const PayOferta = ({ type }) => (
  <p className={cx('oferta')}>
    Нажимая &laquo;
    {ofertaType[type].name}
    &raquo;, я принимаю
    <Link
      className={cx('ofertalink')}
      href={ofertaType[type].link}
      rel="noopener noreferrer"
      target="_blank"
    >
      условия
    </Link>
    использования услуги
  </p>
);

PayOferta.propTypes = {
  type: PropTypes.string,
};

export default PayOferta;
